export const requestsReportsApiPaths = <const>{
    createManualJournalFromBillInvoice: 'requestReports/xero/createManualJournalFromBillInvoice',
    createManualJournalFromPurchaseOrder: 'requestReports/xero/createManualJournalFromPurchaseOrder',
};
